export type ComplaintAsCaseType = 'COMPLAINT' | 'AS';
export type ComplaintAsStatus = 'RECEIVED' | 'IN_PROGRESS' | 'CLOSED' | 'APPROVED';

export interface ComplaintAsCase {
  caseId: number;
  caseNo?: string | null;
  receivedDate?: string | null;
  caseType?: ComplaintAsCaseType | string | null;
  customerName?: string | null;
  customerContact?: string | null;
  productName?: string | null;
  productSpec?: string | null;
  lotNo?: string | null;
  qty?: string | null;
  content?: string | null;
  cause?: string | null;
  actionText?: string | null;
  actionResult?: string | null;
  handlerName?: string | null;
  status?: ComplaintAsStatus | string | null;
  authorName?: string | null;
  reviewerName?: string | null;
  approverName?: string | null;
  approverUserId?: number | null;
  canRevoke?: boolean | null;
  approvalInProgress?: boolean | null;
  pendingApprovalRequestId?: number | null;
  canCancelApproval?: boolean | null;
  canEdit?: boolean | null;
  canClose?: boolean | null;
  closedAt?: string | null;
  remark?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
}

export interface ComplaintAsCasePayload {
  caseNo?: string | null;
  receivedDate?: string | null;
  caseType?: ComplaintAsCaseType | string;
  customerName?: string | null;
  customerContact?: string | null;
  productName?: string | null;
  productSpec?: string | null;
  lotNo?: string | null;
  qty?: string | null;
  content: string;
  cause?: string | null;
  actionText?: string | null;
  actionResult?: string | null;
  handlerName?: string | null;
  status?: ComplaintAsStatus | string;
  remark?: string | null;
}

export const COMPLAINT_AS_TYPE_OPTIONS: { value: ComplaintAsCaseType; label: string }[] = [
  { value: 'COMPLAINT', label: '불만' },
  { value: 'AS', label: 'AS' },
];

export const COMPLAINT_AS_STATUS_OPTIONS: { value: ComplaintAsStatus; label: string }[] = [
  { value: 'RECEIVED', label: '접수' },
  { value: 'IN_PROGRESS', label: '처리중' },
  { value: 'APPROVED', label: '승인' },
  { value: 'CLOSED', label: '종결' },
];

export function complaintAsTypeLabel(value?: string | null) {
  return COMPLAINT_AS_TYPE_OPTIONS.find((o) => o.value === value)?.label || value || '-';
}

export function complaintAsStatusLabel(
  value?: string | null,
  approvalInProgress?: boolean | null
) {
  if (approvalInProgress) return '결재 요청 중';
  return COMPLAINT_AS_STATUS_OPTIONS.find((o) => o.value === value)?.label || value || '-';
}